import {SettingsService} from '../core/settings.service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import * as fromProfile from './store/profile.reducers';
import * as fromUser from '../user/store/user.reducers';
import * as fromApp from './../store/app.reducers';
import {ActivatedRoute} from '@angular/router';

@Injectable()
export class ProfileService {
  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute
  ) {}

  getProfiles(data: any) {
    const params: any = {};
    if (data.limit !== undefined) {
      params.limit = data.limit;
    }
    if (data.page !== undefined) {
      params.page = data.page;
    }
    if (data.profile !== undefined) {
      params.profile = data.profile;
    }
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'profiles',
      {
        params: params
      }
    );
  }

  addProfile(name: string, channelType: string, params: any) {
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'profiles',
      {
        profile: name,
        channel_type: channelType
      }
    );
  }

  addProfileCheck(name: string, channelType: string) {
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'report/basic/add',
      {
        profile: name,
        channel_type: channelType
      }
    );
  }

  getProfileCheck(uid: string) {

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'report/basic',
      {
        params: {
          uid: uid
        }
      }
    );
  }

  updateProfileStatus(profileId: number, status: number) {
    return this.httpClient.put(
      this.settingsService.getSetting('apiHost') + 'profiles/' + profileId.toString() + '/statuses/' + status.toString(),
      {}
    );
  }

  getProfile(id: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'profiles/' + id,
      {
        params: p
      }
    );
  }

  getProfileDetail(id: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'profiles/' + id + '/detail',
      {
        params: p
      }
    );
  }

  getProfileProgress(id: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'profiles/' + id + '/progress',
      {
        params: p
      }
    );
  }

  getProfileScore(id: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'profiles/' + id + '/score',
      {
        params: p
      }
    );
  }

  getAudienceStat(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'audiences/' + id + '/stats/' + type,
      {
        params: p
      }
    );
  }

  getAudienceInterest(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'audiences/' + id + '/interests/' + type,
      {
        params: p
      }
    );
  }

  getAudienceLocation(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'audiences/' + id + '/locations/' + type,
      {
        params: p
      }
    );
  }

  getFollowerStat(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'followers/' + id + '/stats/' + type,
      {
        params: p
      }
    );
  }

  getFollowerEngage(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'followers/' + id + '/engages/' + type,
      {
        params: p
      }
    );
  }

  getFollowerEngageIndicator(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'followers/' + id + '/engages/' + type + '/indicator',
      {
        params: p
      }
    );
  }

  getMediaStat(id: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/stat',
      {
        params: p
      }
    );
  }

  getMediaAnalyze(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/analyzes/' + type,
      {
        params: p
      }
    );
  }

  getMediaCommentAnalyze(id: number, type: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'media/' + id + '/comments/' + type + '/analyze',
      {
        params: p
      }
    );
  }

  getAudienceTiktok(id: number, params: any = {}) {
    const p = this.prepareParams(params);

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'api/tiktok/profile/' + id.toString(),
      {
        params: p
      }
    );
  }

  getProfileFollowerRank(id: number, type: number, limit: number, offset: number, sortField: string, sortType: string, params: any = {}) {
    const p = this.prepareParams(params);
    p['limit'] = limit.toString();
    p['offset'] = offset.toString();
    p['type'] = type.toString();
    p['sort_field'] = sortField;
    p['sort_type'] = sortType;

    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'users/' + id + '/rank',
      {
        params: p
      }
    );
  }

  prepareParams(params) {
    const p = {};
    if (params.code !== undefined) {
      p['code'] = params.code;
    }
    return p;
  }

  getProfileEngagementStat() {
    return [
      {
        range: {
          from: 0,
          to: 5000
        },
        description: '< 5 000',
        engage: 5.9
      },
      {
        range: {
          from: 5001,
          to: 10000
        },
        description: '5 000 - 10 000',
        engage: 4.5
      },
      {
        range: {
          from: 10001,
          to: 50000
        },
        description: '10 000 - 50 000',
        engage: 2.9
      },
      {
        range: {
          from: 50001,
          to: 100000
        },
        description: '50 000 - 100 000',
        engage: 1.8
      },
      {
        range: {
          from: 100001,
          to: 500000
        },
        description: '100 000 - 500 000',
        engage: 1.2
      },
      {
        range: {
          from: 500001,
          to: 1000000
        },
        description: '500 000 - 1 000 000',
        engage: 1.0
      },
      {
        range: {
          from: 1000001,
          to: 9999999999999
        },
        description: '1 000 000 +',
        engage: 0.8
      }
    ];
  }


  hasActiveLimit(): Observable<boolean> {
    return this.store.select('user').pipe(
      map(
        (state: fromUser.State) => {
          if (state.user !== null) {
            const limit = state.user.permissions['auditor.limit'];
            return limit > 0;
          }
          return false;
        }
      )
    );
  }

  hasActivePostLimit(): Observable<boolean> {
    return this.store.select('user').pipe(
      map(
        (state: fromUser.State) => {
          if (state.user !== null) {
            let limit = 0;
            if (state.user.permissions['auditor.post.limit'] !== undefined) {
              limit = state.user.permissions['auditor.post.limit'];
            }
            return limit > 0;
          }
          return false;
        }
      )
    );
  }

}
